<template>
    <div>
        <Counter
            v-if="max"
            class="p-2"
            :class="selected === max ? 'text-lemon-green' : 'text-gray-800'"
            :current="selected"
            :total="max"
            :label="$t('home.onboarding.selected')"
        />
        <div
            class="grid gap-3"
            :class="[
                splitMobile
                    ? `grid-cols-${columns}`
                    : `md:grid-cols-${columns}`,
                { 'items-center': !grid.md },
            ]"
        >
            <CheckboxField
                v-for="option in options"
                :key="option.value"
                v-model="inputValue"
                :value="option.value"
                lg
                rounded
                :name="option.value"
                :label="option.text"
                :label-classes="labelClasses"
            />
            <slot></slot>
        </div>
    </div>
</template>

<script setup>
import Counter from "@/Components/Counter.vue";
import CheckboxField from "@/Components/FormFields/CheckboxField.vue";
import { useModelWrapper } from "@/Helpers/modelWrapper.js";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useGrid } from "vue-screen";

const props = defineProps({
    modelValue: {
        type: Array,
        default: () => [],
    },
    options: {
        type: Array,
        default: () => [],
    },
    max: {
        type: Number,
        default: null,
    },
    columns: {
        type: Number,
        default: 1,
    },
    labelClasses: {
        type: String,
        default: "",
    },
});

const { t } = useI18n({ useScope: "global" });
const emit = defineEmits(["update:modelValue"]);
const inputValue = useModelWrapper(props, emit, (value) =>
    props.max ? value.splice(0, props.max) : value
);
const grid = useGrid("tailwind");

const options = computed(() =>
    props.options.map((option) =>
        typeof option !== "string"
            ? option
            : {
                  text: t(option),
                  value: option,
              }
    )
);

const selected = computed(() => inputValue.value?.length ?? 0);
</script>
